import { ComponentType, ElementType, forwardRef, HTMLAttributes } from 'react'

export interface BoxProps extends Omit<HTMLAttributes<HTMLOrSVGElement>, 'className'>  {
  /** Valid HTML tag to be used to render the element, default is div */
  as?: ComponentType | ElementType;
  /** Use it to overwrite the default container styles, you may need to make some styles !important */
  className?: string;
}

const Box = forwardRef<HTMLDivElement, BoxProps>(({
  as: Tag = 'div',
  className,
  children,
  ...props
}: BoxProps, ref) => {
  return (
    <Tag ref={ref}  className={className} {...props}>{children}</Tag>
  )
})

export default Box